const Component = (props: any) => {
  const { title, extra } = props;
  return (
    <div className="pageTitle">
      <div className="t1">{title}</div>
      {extra ?
        <div className="pageTopExtra">
          {extra}
        </div>
        : ''}
    </div>
  );
};


export default Component;